import { fetchWrapper, handleResponse, buildOpts, hcUrl } from 'services/RequestService/helpers';

const getRecommendedMealsForBasket = async ({ params }) => {
  const queryParams = params.extrasStage ? '?extras_stage=true' : '';
  const response = await fetchWrapper(
    hcUrl(`/weekly_basket/${params.menuSlug}/recommendations${queryParams}`),
    buildOpts()
  );
  return handleResponse(response);
};

export { getRecommendedMealsForBasket };
